import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reverse-engineering-on-android-mobile-application',
  templateUrl: './reverse-engineering-on-android-mobile-application.component.html',
  styleUrls: ['./reverse-engineering-on-android-mobile-application.component.css']
})
export class ReverseEngineeringOnAndroidMobileApplicationComponent implements OnInit {

  heading = "Reverse Engineering on Android Mobile Applications: How It Works and Business Impacts";
  subheading = "";
  innerWidth:number = window.innerWidth;

  constructor() { }

  ngOnInit(): void {
  }

  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
